import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

// Color picker button component
export const ColorPickerButton = ({ colors, onSelect, currentColor, icon: Icon, title }) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-8 px-2"
          title={title}
        >
          <Icon className="w-4 h-4" />
          <div
            className="w-3 h-3 rounded-sm ml-1 border border-gray-300"
            style={{ backgroundColor: currentColor || colors[0].color }}
          />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-2" align="start">
        <div className="grid grid-cols-3 gap-1">
          {colors.map((c) => (
            <button
              key={c.color}
              onClick={() => onSelect(c.color)}
              className="w-8 h-8 rounded border border-gray-200 hover:scale-110 transition-transform"
              style={{ backgroundColor: c.color }}
              title={c.name}
            />
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
